import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the CSI admin/coach lists (question bank, score bands,
// responses in CSIManagement). A stack of card rows matching those lists, rather
// than a "Loading…" line. Renders inner content only. `rows` controls the count.
export default function CSIListSkeleton({ isDarkMode, rows = 5 }) {
    const cardCls = `rounded-2xl border ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className="space-y-3">
                {Array.from({ length: rows }).map((_, i) => (
                    <div key={i} className={`${cardCls} p-4`}>
                        <div className="flex items-center gap-3">
                            <div className="flex-1 min-w-0">
                                <Skeleton width="45%" height={15} />
                                <Skeleton width="25%" height={12} className="mt-2" />
                            </div>
                            <Skeleton width={70} height={24} borderRadius={999} />
                        </div>
                    </div>
                ))}
            </div>
        </SkeletonTheme>
    );
}
